import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const ModalLeerSmtpCredential = ({ isOpen, toggle, selectedSmtpCredential }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Ver Credencial SMTP</ModalHeader>
            <ModalBody>
                {selectedSmtpCredential ? (
                    <div>
                        <p><strong>ID:</strong> {selectedSmtpCredential.id}</p>
                        <p><strong>Usuario:</strong> {selectedSmtpCredential.usuario}</p>
                        <p><strong>Contraseña:</strong> *****</p>
                        <p><strong>Host SMTP:</strong> {selectedSmtpCredential.smtp_host}</p>
                        <p><strong>Puerto:</strong> {selectedSmtpCredential.port}</p>
                    </div>
                ) : (
                    <p>No se ha seleccionado una credencial SMTP.</p>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Cerrar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalLeerSmtpCredential;